<template>
  <div class="checkbox-container" role="button" @click="updateValue">
    <div
      :class="[
        correct && solving ? 'correct' : '',
        !correct && solving ? 'incorrect' : '',
        'custom-check',
      ]"
    >
      <div :class="[check ? 'checked' : '', 'fill']">
        <div v-if="solving && correct && check" class="icon">✓</div>
        <div v-if="solving && !correct && check" class="icon">✖</div>
      </div>
    </div>
    <div class="slot">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: {
    num: String,
    value: Array, // this is the v-model!
    correct: Boolean,
    solved: Boolean,
    solving: Boolean,
  },
  data() {
    return {
      check: false,
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.check = newVal.includes(this.num);
    },
  },
  methods: {
    updateValue(e) {
      if (e.target.className.includes("dict-link")) return;

      if (this.solved || this.solving) {
        return;
      }
      this.check = !this.check;
      let value = [].concat(this.value); // the value prop is the v-model that gets passed
      if (!this.check && value.includes(this.num)) {
        value.splice(value.indexOf(this.num), 1);
      } else {
        value.push(this.num);
      }
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
  user-select: none;

  .custom-check {
    width: 22px;
    height: 22px;
    transition: all 0.3s ease-in-out;
    border: 1px solid $blue;
    display: inline-block;
    width: 100%;
    max-width: 22px;
    height: 22px;
    z-index: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 3px;
    user-select: none;
    align-self: flex-start;

    &.correct {
      background-color: $green;
      .checked.fill {
        background-color: transparent;
        .icon {
          color: #fff;
        }
      }
    }
    &.incorrect {
      background-color: #fff;
      .checked.fill {
        background-color: #fff;
      }
    }

    .fill {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      color: #ffffff;
      user-select: none;

      .icon {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 1px;
        font-size: 12px;
        line-height: 12px;
        user-select: none;
        color: #000;
      }

      &.checked {
        background-color: $blue;
        user-select: none;
      }
    }
  }

  .slot {
    margin-left: 10px;
    flex: 1 0;
    color: #000;
    user-select: none;
    span {
      color: #000;
      user-select: none;

      span.dict-link {
        color: $green;
      }
    }
  }
}
</style>
